import { apiRequest } from '../../../../api/client';

export const checkEmailExists = async (email) => {
  try {
    const result = await apiRequest('/api/auth/email-exists', {
      method: 'POST',
      body: { email },
    });
    return result.exists;
  } catch (error) {
    console.error('Error checking email:', error);
    if (error.status === 400 || error.body?.code === 'invalid-argument') {
      return null;
    }
    throw error;
  }
};
